export const HotFlagCodes: { key: string; value: string }[] = [
  { key: "95", value: "PERFECTION ONLY" },
  { key: "99", value: "No Order" },
];

export type HotFlagRadioButtonType = "po" | "requisition";